import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import userProfileService from '@/services/userProfile.service';
import { AUTH_STATE } from '@/types';

export const useCurrentUserProfile = () => {
  const { state } = useAuth();

  return useQuery({
    queryKey: ['user-profile'],
    queryFn: () => userProfileService.getProfile(),
    enabled: state === AUTH_STATE.AUTHENTICATED,
  });
};
